/**
 * vuex
 */
const state = {
    keepAliveShop: {
        shopId: -1,
        productId: -1,
        contentCompositionProductAllScrollTop: 0,
        contentCompositionProductAllTypeScrollTop: 0,
        contentCompositionProductTypeScrollTop: 0,
        contentCompositionProductListScrollTop: 0,
        activeCompositionContentTab: '',
    }
}

const getters = {

}

const mutations = {
    setKeepAliveShop(state, data) {
        state.keepAliveShop = data;
    },
}

const actions = {
    
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
